#@import Booking.Collections.Base
#@import Booking.Models.Option
#@export Booking.Collections.Options

class Booking.Collections.Options extends Booking.Collections.Base
  model: Booking.Models.Option

  comparator: (model) ->
    model.getPrice()

  selectable: ->
    @filter (option) -> option.isSoldOut() is false

  cheapest: ->
    @sortBy((option) -> option.getPrice())[0]
